// extracted by mini-css-extract-plugin
export default {"drinkCard":"DrinkList_drinkCard__lh7aE"};